import { envio } from "./envio.js";
import { graph } from "./graph.js";

export const indexers = {
  envio,
  graph,
};
